import { Route } from '@angular/router';
import { SchedulePermissions } from '@malirang/common';
import { RoleGuard } from '../guards/role-guard/role.guard';
import { LayoutComponent } from './layout/layout.component';
import { blankRoutes } from './routes/blank.routes';
import { centerRoutes } from './routes/center.routes';
import { childRoutes } from './routes/child.routes';
import { contentRoutes } from './routes/content.routes';
import { customerRoutes } from './routes/customer.routes';
import { myPageRoutes } from './routes/my-page.routes';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'schedule',
  },
  ...blankRoutes,
  {
    path: '',
    canActivateChild: [RoleGuard],
    component: LayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'schedule',
        pathMatch: 'full',
      },
      {
        path: 'withdraw',
        loadComponent: () => import('./pages/my-page/withdraw/withdraw.page'),
      },
      ...centerRoutes,
      ...myPageRoutes,
      ...childRoutes,
      ...customerRoutes,
      ...contentRoutes,
      {
        path: 'no-role',
        title: `권한 없음`,
        loadComponent: () => import('../guards/role-guard/no-role.page'),
      },
      // 임시 주석처리
      // {
      //   path: 'subscription',
      //   title: `구독`,
      //   loadComponent: () => import('./pages/subscription/subscription.page'),
      // },
      {
        path: 'schedule',
        title: `일정`,
        data: {
          requiredRoles: [SchedulePermissions.SCHEDULE_READ],
        },
        loadComponent: () => import('./pages/schedule/schedule.page'),
      },
      {
        path: 'guardian',
        children: [
          {
            path: 'form',
            loadComponent: () =>
              import('./pages/guardian/create-guardian/create-guardian.page'),
          },
        ],
      },
      {
        path: 'ticket',
        children: [
          {
            path: 'form',
            loadComponent: () =>
              import('./pages/ticket/create-ticket/create-ticket.page'),
          },
        ],
      },
      {
        path: 'inspection',
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/inspection/inspection.page'),
          },
          {
            path: 'form/:childId',
            loadComponent: () =>
              import('./pages/inspection/inspection-form/inspection-form.page'),
          },
        ],
      },
    ],
  },
];
